import { render, staticRenderFns } from "./ProductTourCard.vue?vue&type=template&id=74bf4af9&scoped=true"
import script from "./ProductTourCard.vue?vue&type=script&lang=js"
export * from "./ProductTourCard.vue?vue&type=script&lang=js"
import style0 from "./ProductTourCard.vue?vue&type=style&index=0&id=74bf4af9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf4af9",
  null
  
)

export default component.exports